module.exports = __webpack_public_path__ + "static/media/followed.d2ef3a56.svg";